enum Variant {
  Neutral = "neutral",
  Primary = "primary",
  Success = "success",
  Danger = "danger",
  Warning = "warning",
  Info = "info"
}

export default Variant
